// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__4S4Gm","letterWithButton":"Hero_letterWithButton__jhomv","playButton":"Hero_playButton__is_vC","heroRu":"Hero_heroRu__dF3Cc"};